import { useState } from 'react';
import { Link } from 'react-router-dom';
import Links from '../constants/Links';
import Hamburger from '../constants/Hamburger';
import '../css/header.scss';
import { MailOpen, Phone } from 'lucide-react';
// import { LanguageSwitcher } from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const [highlighted, highlight] = useState(window.location.pathname.substring(1));
  const [show, setShow] = useState(false);

  const ShowHideMenu = (test: string, show: boolean) => {
    highlight(test);
    setShow(show);
  };
  
  const {t} = useTranslation('links');

  return (
    <nav>
      <div className="navbar">
        <div className="navbar-header">
          <div className="logo">
            <Link onClick={() => ShowHideMenu('', false)} className="home" to="/">
              <img src="/images/Logo-navette-privee-koffi-300x73.jpg" alt="Logo Koffi Transport" />
            </Link>

            <span className="logo_info">
              <span className="color-white">
                <MailOpen className="icons" size={16} color="#D9AA72" />
                <a href="mailto:info@koffi.be">info@koffi.be</a></span> |
              <Phone className="icons" size={16} color="#D9AA72" />
              <span className="color-white">0473 19 94 70</span>
            </span>
          </div>
        </div>
        <Hamburger onMenuClick={() => { ShowHideMenu(highlighted, !show); }} />
        <div id="navbar-menu" className={`navbar-collapse ${show ? '' : ' hidden'}`}>
          <ul className="nav navbar">
            {Links.map((link) => {
              return (
                <li key={link.type}>
                  <Link onClick={() => ShowHideMenu(link.url, false)} to={`/${link.url}`} className={highlighted === link.url ? 'selected' : ''}>
                    {t(link.type).toUpperCase()}
                  </Link>
                </li>)
            })}
            {/* <LanguageSwitcher /> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
